import React from "react";
import HomeHero from "../components/home/HomeHero";
import TrustedBy from "../components/home/TrustedBy";
import StatsBand from "../components/home/StatsBand";
import ValueProps from "../components/home/ValueProps";
import ProductShowcase from "../components/home/ProductShowcase";
import HowItWorks from "../components/home/HowItWorks";
import IndustriesSection from "../components/home/IndustriesSection";
import CaseStudyHighlight from "../components/home/CaseStudyHighlight";
import IntegrationsStrip from "../components/home/IntegrationsStrip";
import TestimonialsSection from "../components/home/TestimonialsSection";
import HomeFaq from "../components/home/HomeFaq";
import CtaStrip from "../components/home/CtaStrip";

const Home = () => (
  <>
    <HomeHero />
    <TrustedBy />
    <StatsBand />
    <ValueProps />
    <ProductShowcase />
    <HowItWorks />
    <IndustriesSection />
    <CaseStudyHighlight />
    <IntegrationsStrip />
    <TestimonialsSection />
    <HomeFaq />
    <CtaStrip />
  </>
);

export default Home;
